import React, { useEffect, useState } from "react";
import { LayoutGrid, MapPin } from "lucide-react";
import Dashboard from "../pages/Dashboard";
import LyteMap from "../pages/LyteMap";
import { useLang } from "../context/LanguageContext";
import { MAP_HOME_ON_MOBILE, CLASSIC_HOME_KEY as CLASSIC_KEY } from "../config/home";
import { useContent } from "../hooks/useContent";

export default function HomeRoute() {
  const { t } = useLang();
  const cms = useContent("home") || {};
  const [classic, setClassic] = useState(() => localStorage.getItem(CLASSIC_KEY) === "1");
  const [mobile, setMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  if (!(MAP_HOME_ON_MOBILE || cms.mapHomeOnMobile) || !mobile || classic) return <Dashboard />;

  return (
    <div className="space-y-4" data-testid="map-home">
      <div className="flex items-center justify-between gap-2 rounded-2xl border border-[#16a34a]/30 bg-[#e7f6ec] dark:bg-[#16341f] px-3 py-2">
        <span className="flex items-center gap-1.5 text-xs font-semibold text-[#0e7a3c] dark:text-[#7ee0a3]">
          <MapPin size={13} /> {t("map.homeMapNote")}
        </span>
        <button onClick={() => { localStorage.setItem(CLASSIC_KEY, "1"); setClassic(true); }} data-testid="map-home-classic-btn"
          className="shrink-0 inline-flex items-center gap-1.5 text-xs font-bold text-foreground bg-card border border-border hover:border-[#16a34a] px-3 py-2 rounded-xl transition-colors">
          <LayoutGrid size={13} /> {t("map.classicHome")}
        </button>
      </div>
      <LyteMap />
    </div>
  );
}
